import type { MouseEvent, KeyboardEvent } from 'react';

export function SkipLink() {
  const handleSkip = (e: MouseEvent<HTMLAnchorElement> | KeyboardEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const mainContent = document.getElementById('main-content');
    if (mainContent) {
      mainContent.setAttribute('tabindex', '-1');
      mainContent.focus();
      mainContent.scrollIntoView({ behavior: 'smooth', block: 'start' });
      
      const handleBlur = () => {
        mainContent.removeAttribute('tabindex');
        mainContent.removeEventListener('blur', handleBlur);
      };
      mainContent.addEventListener('blur', handleBlur);
    }
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLAnchorElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      handleSkip(e);
    }
  };

  return (
    <a
      href="#main-content"
      onClick={handleSkip}
      onKeyDown={handleKeyDown}
      className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[100] focus:px-4 focus:py-2 focus:bg-primary focus:text-primary-foreground focus:rounded-md focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
      data-testid="link-skip-to-content"
    >
      Skip to main content
    </a>
  );
}
